import { CalendarPicker } from './CalendarPicker';
import { RANGE_PRESETS, presetRange, lastDaysRange } from '../../utils/periods';

// From / To date pickers + quick-range presets (1M/3M/6M/1Y) — the same date
// controls used on the Reports page. Controlled: the parent holds
// { from, to, preset } and receives the full next state via `onChange`.
// Picking a preset sets from/to to the last N months of data; clicking the
// active preset again clears the range; editing From/To manually clears the preset.
const labelCls = 'block mb-1 text-sm font-medium text-slate-600 dark:text-slate-300';

export function RangeFilters({ from, to, preset, dateRange, onChange }) {
  const applyPreset = (p) => {
    // Deselecting the active preset resets to the default last-7-days window (not all-time).
    if (preset === p.key) {
      const { from: f, to: t } = lastDaysRange(7, dateRange?.max);
      onChange({ from: f, to: t, preset: '' });
      return;
    }
    const { from: f, to: t } = presetRange(p.months, dateRange?.max);
    onChange({ from: f, to: t, preset: p.key });
  };

  return (
    <>
      <div className="w-full sm:w-40">
        <span className={labelCls}>From</span>
        <CalendarPicker
          value={from}
          onChange={(v) => onChange({ from: v, to, preset: '' })}
          min={dateRange?.min}
          max={to || dateRange?.max}
        />
      </div>
      <div className="w-full sm:w-40">
        <span className={labelCls}>To</span>
        <CalendarPicker
          value={to}
          onChange={(v) => onChange({ from, to: v, preset: '' })}
          min={from || dateRange?.min}
          max={dateRange?.max}
        />
      </div>
      <div>
        <span className={labelCls}>Quick range</span>
        <div className="inline-flex rounded-full border border-slate-200 dark:border-white/10 bg-slate-100/70 dark:bg-white/5 p-1">
          {RANGE_PRESETS.map((p) => (
            <button
              key={p.key}
              type="button"
              onClick={() => applyPreset(p)}
              className={`rounded-full px-3 py-1.5 text-sm font-medium transition ${
                preset === p.key
                  ? 'bg-brand-gradient text-white shadow-brand'
                  : 'text-slate-600 dark:text-slate-300 hover:text-slate-800 dark:hover:text-white'
              }`}
            >
              {p.label}
            </button>
          ))}
        </div>
      </div>
    </>
  );
}
